import {
  createBlocContext,
  createBlocProvider
} from "@kernel/frontend-react-app";
import { useContext } from "react";
import { RoomBloc } from "./RoomBloc";

export const RoomContext = createBlocContext<RoomBloc>();

export function useRoomContext() {
  const ctx = useContext(RoomContext);
  return ctx;
}

export const RoomBlocProvider = createBlocProvider<RoomBloc>(
  RoomBloc.create(),
  RoomContext
);
